import request from '../../../../../../../api/request';
import { generatePath } from 'react-router-dom';

const CURRICULUM_PROGRESS = {
  HISTORY_DOWNLOAD: (studyPlanEnrollmentId: number | string) =>
    generatePath(
      `teacher-portal/student-file/academic-history/student-curriculum-progress/students/:studyPlanEnrollmentId/history-document`,
      { studyPlanEnrollmentId },
    ),
};

export function getCourseHistoryPdf(studyPlanEnrollmentId: number) {
  const url = CURRICULUM_PROGRESS.HISTORY_DOWNLOAD(studyPlanEnrollmentId);
  return request(url, {
    method: 'GET',
    responseType: 'blob',
  });
}
